"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
const getStorage = () => {
    return globalThis.sessionStorage;
};
const isSupported = () => !!getStorage();
const get = (key) => {
    const val = getStorage().getItem(key);
    if (val !== null)
        return val;
    return;
};
const pop = (key) => {
    const value = get(key);
    remove(key);
    return value;
};
const getObject = (key) => {
    const val = get(key);
    if (val)
        return JSON.parse(val);
    return;
};
const set = (key, value) => {
    if (typeof value === 'object')
        value = JSON.stringify(value);
    getStorage().setItem(key, value);
};
const remove = (key) => {
    getStorage().removeItem(key);
};
exports.Storage = {
    isSupported,
    get,
    getObject,
    pop,
    set,
    remove,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQU0sVUFBVSxHQUFHLEdBQXVCLEVBQUU7SUFDMUMsT0FBTyxVQUFVLENBQUMsY0FBYyxDQUFDO0FBQ25DLENBQUMsQ0FBQTtBQUVELE1BQU0sV0FBVyxHQUFHLEdBQVksRUFBRSxDQUFDLENBQUMsQ0FBQyxVQUFVLEVBQUUsQ0FBQztBQUVsRCxNQUFNLEdBQUcsR0FBRyxDQUFDLEdBQVcsRUFBc0IsRUFBRTtJQUM5QyxNQUFNLEdBQUcsR0FBRyxVQUFVLEVBQUUsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7SUFFdEMsSUFBSSxHQUFHLEtBQUssSUFBSTtRQUNkLE9BQU8sR0FBRyxDQUFDO0lBRWIsT0FBTztBQUNULENBQUMsQ0FBQTtBQUVELE1BQU0sR0FBRyxHQUFHLENBQUMsR0FBVyxFQUFzQixFQUFFO0lBQzlDLE1BQU0sS0FBSyxHQUFHLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUN2QixNQUFNLENBQUMsR0FBRyxDQUFDLENBQUM7SUFDWixPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMsQ0FBQTtBQUVELE1BQU0sU0FBUyxHQUFHLENBQUksR0FBVyxFQUFpQixFQUFFO0lBQ2xELE1BQU0sR0FBRyxHQUFHLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUNyQixJQUFJLEdBQUc7UUFDTCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7SUFFekIsT0FBTztBQUNULENBQUMsQ0FBQTtBQUVELE1BQU0sR0FBRyxHQUFHLENBQUMsR0FBVyxFQUFFLEtBQVUsRUFBUSxFQUFFO0lBQzVDLElBQUksT0FBTyxLQUFLLEtBQUssUUFBUTtRQUMzQixLQUFLLEdBQUcsSUFBSSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUVoQyxVQUFVLEVBQUUsQ0FBQyxPQUFPLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQ25DLENBQUMsQ0FBQTtBQUVELE1BQU0sTUFBTSxHQUFHLENBQUMsR0FBVyxFQUFRLEVBQUU7SUFDbkMsVUFBVSxFQUFFLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0FBQy9CLENBQUMsQ0FBQTtBQUVZLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLFdBQVc7SUFDWCxHQUFHO0lBQ0gsU0FBUztJQUNULEdBQUc7SUFDSCxHQUFHO0lBQ0gsTUFBTTtDQUNQLENBQUMifQ==